// extracted by mini-css-extract-plugin
module.exports = {"content":"layout_content__tlva7","layout":"layout_layout__TUW4Q","cover":"layout_cover___cVm3"};